<template>
  <div>
    <Navigation />
    <div class="grid__section">
    <section class="section__container top__container blog__details">
               

      <h1 class="title center__text">
        ENVOI SMS PARTI POLITIQUE / SYNDICAT
      </h1>
       <img class="card__image" src="/../images/vote.png" alt="" />
      <p>
        La communication avec le public est essentielle pour un parti politique. La réussite du parti repose sur
        la communication de ses valeurs, principes, normes et idéaux.
      </p>
      <p>
        Servicesms.sn offre la possibilité de moderniser votre image et d'améliorer votre efficacité grâce à l'envoi automatique de SMS.
        De plus, nos services permettent à vos adhérents de se sentir davantage impliqués dans la vie sociale de votre parti.
      </p>
      <p>
        Pour une stratégie de communication politique innovante, directe et efficace, Servicesms.sn vous offre une gamme complète 
        de services et d'options pour atteindre vos objectifs. Envoyez des SMS à tous vos adhérents en un clic pour les inviter à 
        des événements politiques ou à des réunions d'information. Utilisez également l'envoi de SMS pour attirer de nouveaux adhérents
        à votre cause et augmenter vos chances aux élections.
      </p>
      <p>
        Le SMS est le moyen de communication le plus efficace, car il est directement reçu par vos destinataires et lu en quelques
        minutes seulement. C'est pourquoi Servicesms.sn vous offre la possibilité de rassembler et de mobiliser un grand nombre de
        personnes en un temps record.
      </p>
      <p>
        Un parti politique a également l'obligation de remercier ses partisans, que ce soit après une victoire ou une défaite.
        Le SMS personnalisé, grâce au publipostage, vous permet de maintenir une proximité avec vos adhérents et de transmettre 
        une image publique de qualité.
      </p>

      <h2>
        Un parti politique peut bénéficier de l'envoi de SMS dans différentes situations.
      </h2>
        <li>Animer une campagne électorale <br /></li>
        <li>Inviter les adhérents à une réunion d'information <br /></li>
        <li>Mobiliser pour une réunion militante <br /></li>
        <li>Mobiliser autour d'une interview <br /></li>
        <li>Mobiliser pour une manifestation <br /></li>
        <li>Annoncer les résultats d'une élection <br /></li>
        <li>Remercier les adhérents et militants après une campagne <br /></li>
        <li>Appeler au vote <br /></li>
        <li>Annoncer les résultats<br /></li>
        <li>Faire appel aux dons<br /></li>
      
  <h2>Quelques exemples de SMS :</h2>
  <div class="cards">
    <div class="card">
      <img class="card__image" src="/../images/politique-1.png" />
    </div>
    <div class="card">
      <img class="card__image" src="/../images/politique-2.png" />
    </div>
    <div class="card">
      <img class="card__image" src="/../images/politique-3.png" />
    </div>
  </div>
    </section>
   <SideNav/>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navigation from "./Navigation";
import Footer from "./Footer";
import SideNav from "./SideNav";
export default {
  components: {
    Navigation,
    Footer,
    SideNav
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/base.scss";
</style>
